import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import Rakeback from "./rakeback";
import Reload from "./reload";
import UserProgress from "../../../components/user-progress";
import BenefitsModal from "./benefits";
// import BoostModal from "./boost";
import associateServices from "../../../services";
import BonusModal from "./bonus";
import SvgIcon from "../../../components/svg-icon";
import CorrectionModal from "./correction";
import BonusRedeemModal from "./bonus-redeem";


const ModalVip = props => {

    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {handleClose} = props

    useEffect(() => {
        if (authenticated) {
            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('wallet-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'


            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')
            }
        }
    }, [authenticated])

    useEffect(() => {
        checkForTabs(selectedWallet?.code)
    }, [selectedWallet?.code])

    const getRakebacks = () => {
        associateServices.getRakebacks({}).then(res => {
            if (res?.data?.length >= 1)
                setItems(prevState => [...prevState, 'rakeback'])
        })
    }

    const getReloads = (code) => {
        if (!code) {
            console.log('NO CODE FOUND')
            return false;
        }

        associateServices.getAvailableReloads({
            code
        }).then(res => {
            if (res?.data?.length >= 1 || res?.data?.id)
                setItems(prevState => [...prevState, 'reload'])
        })
    }

    const getCorrections = (code) => {
        if (!code) {
            console.log('NO CODE FOUND')
            return false;
        }

        associateServices.checkCorrection({
            code
        }).then(res => {
            if (res?.data?.length >= 1 || res?.data?.id)
                setItems(prevState => [...prevState, 'correction'])
        })
    }
    const checkBonus = (code) => {
        if (!code) {
            console.log('NO CODE FOUND')
            return false;
        }

        associateServices.checkUserHasActiveBonus({
            code
        }).then(res => {
            if (res?.data?.length >= 1 || res?.data?.id)
                setItems(prevState => [...prevState, 'bonus'])
        })
    }

    const checkForTabs = (code) => {
        checkBonus(code)
        getReloads(code)
        getCorrections(code)
        getRakebacks()
    }
    const [items, setItems] = useState([
        'progress',
        'benefits',
        // 'boost',
        'bonus-code'
    ])

    const {t} = useTranslation()
    const {modalTab} = useSelector(state => state.globalReducer)
    const [activeType, setActiveType] = useState('deposit')

    useEffect(() => {
        if (modalTab) {
            setActiveType(modalTab)
        }
    }, [modalTab])

    const [searchParams, setSearchParams] = useSearchParams()
    // const handleClose = () => {
    //     if (searchParams.has('modal')) {
    //         searchParams.delete('modal');
    //         setSearchParams(searchParams);
    //     }
    //
    //     if (searchParams.has('currency')) {
    //         searchParams.delete('currency');
    //         setSearchParams(searchParams);
    //     }
    //
    //     store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
    // }


    const getDynamicContent = () => {
        switch (activeType) {
            case 'progress':
                return <UserProgress/>

            case 'benefits':
                return <BenefitsModal handleClose={handleClose}/>

            case 'bonus-code':
                return <BonusRedeemModal handleClose={handleClose}/>

            // case 'boost':
            //     return <BoostModal/>

            case 'correction':
                return <CorrectionModal/>

            case 'rakeback':
                return <Rakeback/>


            case 'reload':
                return <Reload/>

            case 'bonus':
                return <BonusModal/>
            default:
                return null;
        }
    }


    const handleActiveType = type => {
        setSearchParams({
            modal: 'vip',
            tab: type
        })
    }
    return (
        <div
            className="modal fade"
            id="wallet-modal"
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <div className="d-flex align-items-center gap-2">
                                <SvgIcon id={'vip-club'}/>
                                <h6 className="modal__title">{t(`modals.vip.tabs.${activeType}`)}</h6>
                            </div>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <ul className="nav nav-tabs tabs-nav tabs-nav--modal">
                            {
                                items?.map(ii => (
                                    <li
                                        onClick={e => handleActiveType(ii)}
                                        className="nav-item" role="presentation"
                                        key={ii}
                                    >
                                        <button
                                            className={`tabs-nav__btn ${activeType === ii ? 'active' : ''}`}
                                            type="button"
                                        >

                                            {t(`modals.vip.tabs.${ii}`)}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                        <div className="tab-content">
                            <div
                                className="tab-pane fade show active"
                                role="tabpanel"
                            >
                                {
                                    getDynamicContent()
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default ModalVip
